<template>
	<form class="flex flex-col justify-center">
		<div
			class="w-full md:w-2/3 lg:w-1/3 mx-auto p-3 mb-6 flex items-center shadow-md cursor-pointer bg-green-200"
			:class="checked === 'default' ? 'workflow-selector-checked' : 'workflow-selector-unchecked'"
			@click="checked = 'default'"
			v-if="this.defaultValue && !this.forceCustomValue"
		>
			<div class="w-1/3">
				<input type="radio" value="default" v-model="checked" />
			</div>
			<div class="w-1/12" :class="checked === 'default' ? 'vertical-separator-checked' : 'vertical-separator-unchecked'"></div>
			<div class="w-full text-left px-5">
				<slot name="default" />
			</div>
		</div>

		<div
			class="w-full md:w-2/3 lg:w-1/3 mx-auto p-3 pb-0 mb-6 flex items-center shadow-md cursor-pointer bg-red-200"
			:class="checked === 'custom' ? 'workflow-selector-checked' : 'workflow-selector-unchecked'"
			@click="setCustomChecked"
		>
			<div class="flex flex-col justify-center w-full">
				<div class="flex items-center mb-4">
					<div class="w-1/3">
						<input type="radio" value="custom" v-model="checked" />
					</div>

					<div class="w-1/12" :class="checked === 'custom' ? 'vertical-separator-checked' : 'vertical-separator-unchecked'"></div>

					<div class="w-full px-5 text-left">
						<slot name="custom"></slot>
					</div>
				</div>

				<hr />

				<div class="flex flex-col justify-center mt-4" v-if="checked === 'custom' && showInputField">
					<BaseInput ref="inputText" v-model="value" :placeholder="placeholder" :required="true" :error-message="customValueErrorMessage">
						<textarea v-model="value" @input="updateValue" :placeholder="placeholder" rows="3" class="w-full resize-none" />
					</BaseInput>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import BaseInput from '../../forms/inputs/BaseInput';
import { validateForm } from '@/plugins/Utils';
export default {
	name: 'DefaultOrValueForm',
	components: { BaseInput },
	inheritAttrs: false,
	watch: {
		checked: function() {
			this.$emit('changeRadio', this.checked);
			this.$emit('input', this.getValue);
		},
	},
	props: {
		customValueErrorMessage: {
			default: function() {
				return this.$t('enter_order_description');
			},
		},
		defaultValue: {
			type: String,
			required: true,
		},
		placeholder: {
			type: String,
		},
		forceCustomValue: {
			type: Boolean,
			default: false,
		},
		showInputField: {
			type: Boolean,
			default: true,
		},
	},
	mounted() {
		if (this.forceCustomValue) {
			this.checked = 'custom';
		}
	},
	computed: {
		getValue: function() {
			return this.checked === 'default' ? this.defaultValue : this.value;
		},
	},
	data() {
		return {
			checked: 'default',
			value: null,
		};
	},
	methods: {
		setCustomChecked() {
			this.checked = 'custom';
			if (!this.showInputField) {
				this.$emit('input', { isNotDefaultLocation: true });
			}
		},
		validate() {
			return validateForm(this.$refs);
		},
		updateValue() {
			this.$emit('input', this.getValue);
		},
		setRadioToDefault() {
			this.checked = 'default';
		},
	},
};
</script>

<style lang="sass" scoped>
.vertical-separator
    content: ''
    width: 1px
@apply border

    &-unchecked:after
        @extend .vertical-separator
        border-color: $sp_blue


    &-checked:after
        @extend .vertical-separator
        border-color: $sp_green

.workflow-selector
    &-unchecked
        border-color: $sp_blue

    &-checked
        border-color: $sp_green
</style>
